import React, { Component } from 'react';
import Grid from "@mui/material/Grid";
import Switch from '../../../components/Switch.js';
import Bubble from '../../../components/Bubble.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import BlockContent from '../../../components/BlockContent.js';
import HeaderDiv from '../../../components/HeaderDiv.js';
import { colors } from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import { selectFieldOptions } from '../../../services/index.js';
import * as localizationMaps from '../../../localization/maps.js';
class OutOfCountry extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    const defaults = this._setData(this.props.data);
    if (this.props.type === "modular") {
      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'outOfCountry', 'outOfCountry', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'outOfCountry', defaults);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const defaults = this._setData(nextProps.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      return;
    }
    if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'outOfCountry', defaults);
    }
  }
  _setOOPDays = data => {
    let oopDays = '';
    for (const name in data) {
      if (name !== 'outOfCountryPeriodAfterReduction' && name.indexOf('outOfCountryPeriod') === 0) {
        if (data[name]) {
          const num = name.replace('outOfCountryPeriod', '');
          const combined = `${num} Days`;
          oopDays = combined;
        }
      }
    }
    return oopDays;
  };
  _setData = data => {
    const defaults = {
      isSelected: data.isSelected || false,
      outOfCountryRollover: data.outOfCountryRollover || 'Lifetime',
      outOfCountryStopLoss: data.outOfCountryStopLoss || 0,
      outOfCountryPeriod30: data.outOfCountryPeriod30 || false,
      outOfCountryPeriod60: data.outOfCountryPeriod60 === undefined ? true : data.outOfCountryPeriod60,
      outOfCountryPeriod90: data.outOfCountryPeriod90 || false,
      outOfCountryPeriod120: data.outOfCountryPeriod120 || false,
      outOfCountryPeriod180: data.outOfCountryPeriod180 || false,
      outOfCountryMax: typeof data.outOfCountryMax === "number" ? data.outOfCountryMax : 5000000,
      outOfCountryIsGraded: data.outOfCountryIsGraded || false,
      outOfCountryReducesBy: typeof data.outOfCountryReducesBy === "number" ? data.outOfCountryReducesBy : 50,
      outOfCountryReducesAtAge: typeof data.outOfCountryReducesAtAge === "number" ? data.outOfCountryReducesAtAge : 70,
      outOfCountryPeriodAfterReduction: data.outOfCountryPeriodAfterReduction || 10,
      includeOutOfCountryMedicalReferral: data.includeOutOfCountryMedicalReferral || false,
      outOfCountryMedicalReferralMax: typeof data.outOfCountryMedicalReferralMax === "number" ? data.outOfCountryMedicalReferralMax : 50000,
      outOfCountryMedicalReferralPerYearReimbursement: typeof data.outOfCountryMedicalReferralPerYearReimbursement === "number" ? data.outOfCountryMedicalReferralPerYearReimbursement : 100,
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      notes: data.notes || null
    };
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _handleOutOfCountryPeriod = value => {
    const dayArray = ['30 Days', '60 Days', '90 Days', '120 Days', '180 Days'];

    // Set all 5 outOfCountryPeriod properties to false in global state
    dayArray.forEach(day => {
      const converted = day.replace(' Days', '');
      this._saveInGlobalState(`outOfCountryPeriod${converted}`, false);
    });

    // Set the selected field to true globally
    const converted = value.replace(' Days', '');
    this._saveInGlobalState(`outOfCountryPeriod${converted}`, true);
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, this.props.tier, 'outOfCountry', 'outOfCountry', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'outOfCountry', field, value);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      isMasterSite,
      revision,
      isRevisionBlock,
      lightTierColor,
      darkTierColor
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    const tierLabelStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 90,
      padding: 5,
      marginRight: 10,
      backgroundColor: lightTierColor
    };
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${i18n.t(tokens.labels.planDesign.outOfCountryAndProvince)} (${revision.revisionID})` : i18n.t(tokens.labels.planDesign.outOfCountryAndProvinceCurrent) : i18n.t(tokens.titles.outOfCountryAndProvince)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flex: 1
      }
    }, this.props.tier && /*#__PURE__*/React.createElement("div", {
      style: tierLabelStyle
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: darkTierColor
    }, this.props.tier.toUpperCase())), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    }))), data.isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.outOfCountryPeriod),
      fullWidth: true,
      value: localizationMaps.fromEnglish('coveragePeriod', this._setOOPDays(data)),
      variant: "outlined",
      onChange: e => this._handleOutOfCountryPeriod(localizationMaps.toEnglish('coveragePeriod', e.target.value)),
      onBlur: e => this._handleOutOfCountryPeriod(localizationMaps.toEnglish('coveragePeriod', e.target.value)),
      error: errors.outOfCountryPeriod,
      select: true,
      selectOptions: [{
        key: 'outOfCountryPeriod30',
        value: i18n.t(tokens.dropdowns.coveragePeriod.thirtyDays)
      }, {
        key: '60 Days',
        value: i18n.t(tokens.dropdowns.coveragePeriod.sixtyDays)
      }, {
        key: 'outOfCountryPeriod90',
        value: i18n.t(tokens.dropdowns.coveragePeriod.ninetyDays)
      }, {
        key: 'outOfCountryPeriod120',
        value: i18n.t(tokens.dropdowns.coveragePeriod.oneTwentyDays)
      }, {
        key: 'outOfCountryPeriod180',
        value: i18n.t(tokens.dropdowns.coveragePeriod.oneEightyDays)
      }]
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.titles.stopLoss),
      prefix: "$ ",
      fullWidth: true,
      value: data.outOfCountryStopLoss,
      variant: "outlined",
      onChange: e => this._handleChange("outOfCountryStopLoss", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryStopLoss", e.target.value),
      error: errors.outOfCountryStopLoss
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.coverage),
      fullWidth: true,
      prefix: "$ ",
      value: data.outOfCountryMax,
      variant: "outlined",
      onChange: e => this._handleChange("outOfCountryMax", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryMax", e.target.value),
      disabled: !isMasterSite
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.coverageRolloverPeriod),
      fullWidth: true,
      value: localizationMaps.fromEnglish('coverageRolloverPeriod', data.outOfCountryRollover),
      variant: "outlined",
      onChange: e => this._handleChange("outOfCountryRollover", localizationMaps.toEnglish('coverageRolloverPeriod', e.target.value)),
      onBlur: e => this._saveInGlobalState("outOfCountryRollover", localizationMaps.toEnglish('coverageRolloverPeriod', e.target.value)),
      error: errors.outOfCountryPeriod,
      select: true,
      selectOptions: selectFieldOptions.coverageRolloverPeriod()
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.isGraded),
      isSelected: data.outOfCountryIsGraded,
      onClick: () => this._saveInGlobalState("outOfCountryIsGraded", !data.outOfCountryIsGraded)
    }))), data.outOfCountryIsGraded && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reducesBy),
      fullWidth: true,
      suffix: "%",
      value: data.outOfCountryReducesBy,
      onChange: e => this._handleChange("outOfCountryReducesBy", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryReducesBy", e.target.value),
      error: errors.outOfCountryReducesBy,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reducesAtAge),
      fullWidth: true,
      value: data.outOfCountryReducesAtAge,
      onChange: e => this._handleChange("outOfCountryReducesAtAge", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryReducesAtAge", e.target.value),
      error: errors.outOfCountryReducesAtAge,
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reducedPeriodDays),
      fullWidth: true,
      value: data.outOfCountryPeriodAfterReduction,
      onChange: e => this._handleChange("outOfCountryPeriodAfterReduction", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryPeriodAfterReduction", e.target.value),
      error: errors.outOfCountryPeriodAfterReduction,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.selectItemsIncluded)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: i18n.t(tokens.labels.planDesign.medicalReferral),
      isSelected: data.includeOutOfCountryMedicalReferral,
      onClick: () => this._saveInGlobalState("includeOutOfCountryMedicalReferral", !data.includeOutOfCountryMedicalReferral)
    }))), data.includeOutOfCountryMedicalReferral && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.reimbursement),
      fullWidth: true,
      suffix: "%",
      value: data.outOfCountryMedicalReferralPerYearReimbursement,
      variant: "outlined",
      onChange: e => this._handleChange("outOfCountryMedicalReferralPerYearReimbursement", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryMedicalReferralPerYearReimbursement", e.target.value),
      error: errors.outOfCountryMedicalReferralPerYearReimbursement
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.lifetimeCoverage),
      fullWidth: true,
      prefix: "$ ",
      value: data.outOfCountryMedicalReferralMax,
      variant: "outlined",
      onChange: e => this._handleChange("outOfCountryMedicalReferralMax", e.target.value),
      onBlur: e => this._saveInGlobalState("outOfCountryMedicalReferralMax", e.target.value),
      error: errors.outOfCountryMedicalReferralMax
    }))), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, i18n.t(tokens.labels.planDesign.planEligibilityTermination)), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, i18n.t(tokens.labels.planDesign.completeFollowing)), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.eligibilityPeriodMonths),
      fullWidth: true,
      value: data.eligibilityPeriod,
      variant: "outlined",
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.minimumHoursPerWeek),
      fullWidth: true,
      value: data.minHoursPerWeek,
      variant: "outlined",
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.planDesign.terminationAge),
      fullWidth: true,
      value: data.terminationAge,
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: i18n.t(tokens.labels.planDesign.additionalRequestsInformation)
    })));
  }
}
export default OutOfCountry;